import { render } from "./PanelSection.vue?vue&type=template&id=2467ce92&scoped=true&ts=true"
import script from "./PanelSection.vue?vue&type=script&lang=ts"
export * from "./PanelSection.vue?vue&type=script&lang=ts"

import "./PanelSection.vue?vue&type=style&index=0&id=2467ce92&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2467ce92"]])

export default __exports__